export const leaveTypes = [
  {
    leave_type: "Maternity",
    description: "Maternity Leave",
  },
  {
    leave_type: "Paternity",
    description: "Paternity Leave",
  },
  {
    leave_type: "Miscarriage",
    description: "Miscarriage Leave",
  },
  {
    leave_type: "SL",
    description: "Sick leave",
  },
  {
    leave_type: "PL",
    description: "Privilege leave",
  },
  {
    leave_type: "RPL",
    description: "Reserved PL",
  },
  {
    leave_type: "CL",
    description: "Casual leave",
  },
  {
    leave_type: "Menstrual",
    description: "Menstrual leave",
  },
  {
    leave_type: "ESIC",
    description: "ESIC",
  },
];
